import { render } from "./ArtShopTermsV20260905.vue?vue&type=template&id=c3fadd18&scoped=true"
const script = {}

import "./ArtShopTermsV20260905.vue?vue&type=style&index=0&id=c3fadd18&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3fadd18"]])

export default __exports__